var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "800" },
      model: {
        value: _vm.brandSearchDialog,
        callback: function ($$v) {
          _vm.brandSearchDialog = $$v
        },
        expression: "brandSearchDialog",
      },
    },
    [
      _c("customDialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(" " + _vm._s(_vm.t("brandSelect")) + " "),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: {
                      click: function ($event) {
                        _vm.brandSearchDialog = false
                      },
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "ma-0 pa-0",
                        staticStyle: { "min-height": "150px" },
                        attrs: { cols: "12" },
                      },
                      [
                        _c(
                          "v-item-group",
                          {
                            staticClass: "ma-0 pa-0",
                            attrs: {
                              dense: "",
                              dark: "",
                              "hide-details": "",
                              column: false,
                              mandatory: "",
                            },
                            model: {
                              value: _vm.selectedBrands,
                              callback: function ($$v) {
                                _vm.selectedBrands = $$v
                              },
                              expression: "selectedBrands",
                            },
                          },
                          [
                            _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { align: "center" },
                              },
                              _vm._l(_vm.brandList, function (item, index) {
                                return _c(
                                  "v-col",
                                  {
                                    key: index,
                                    staticClass: "ma-0 pa-0 ml-2 mr-2",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c("v-item", {
                                      attrs: { value: item },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var active = ref.active
                                              var toggle = ref.toggle
                                              return [
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass:
                                                      "ma-0 pa-2 grey_item",
                                                    class: {
                                                      selected_item: active,
                                                    },
                                                    attrs: { cols: "auto" },
                                                    on: { click: toggle },
                                                  },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-0",
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        active
                                                          ? _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0 mr-1",
                                                                attrs: {
                                                                  color:
                                                                    "#008DD0",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-radiobox-marked"
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0 mr-1",
                                                                attrs: {
                                                                  dark: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-radiobox-blank"
                                                                ),
                                                              ]
                                                            ),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.brandName +
                                                                " (" +
                                                                item.count +
                                                                ")"
                                                            ) +
                                                            " "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "ma-0 pa-0 mt-5 mb-2",
                        attrs: { cols: "12" },
                      },
                      [
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0",
                            attrs: { align: "center", justify: "center" },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-2",
                                attrs: {
                                  width: "8rem",
                                  height: "auto",
                                  id: "grey_btn",
                                  elevation: "0",
                                },
                                on: { click: _vm.reset },
                              },
                              [_vm._v(" " + _vm._s(_vm.t("reset")) + " ")]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-2 ml-2",
                                attrs: {
                                  width: "8rem",
                                  height: "auto",
                                  id: "grey_btn",
                                  elevation: "0",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.brandSearchDialog = false
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.t("cancel")) + " ")]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-2 ml-2",
                                attrs: {
                                  width: "8rem",
                                  height: "auto",
                                  id: "blue_btn",
                                  elevation: "0",
                                },
                                on: { click: _vm.editBrands },
                              },
                              [_vm._v(" " + _vm._s(_vm.t("confirm")) + " ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }